import { PropertyChangedInformation } from '@app/shared/data/http';
import { Notification } from '@app/shared/data/messaging';

@Notification({
  name: 'UserUpdatedNotification',
})
export class UserUpdatedNotification {
  public userId: string;
  public userName: string | null;
  public changes: PropertyChangedInformation[] = [];
}

@Notification({
  name: 'UserAvatarUpdatedNotification',
})
export class UserAvatarUpdatedNotification {
  public userId: string;
  public avatar?: string | null;
}